export default {
    data() {
        return {
            user: null
        }
    }
}